import theme from '../../theme';

export const FORM_CONTROL_BACKGROUND_COLORS = {
  primary: theme.palette.background.input,
  secondary: 'rgba(255, 255, 255, 0.7)',
};

export const FORM_CONTROL_BORDER_COLORS = {
  primary: theme.palette.border.secondary,
  secondary: theme.palette.border.primary,
};

export const FORM_CONTROL_INPUT_PLACEHOLDER_COLORS = {
  primary: theme.palette.text.primary,
  secondary: theme.palette.text.primary,
};

export const FORM_CONTROL_LABEL_FONT_WEIGHT = {
  primary: 600,
  secondary: 600,
};

export const FORM_CONTROL_PADDING = {
  small: `${theme.spacing(0.25)} ${theme.spacing(1.5)}`,
  medium: `${theme.spacing(0.5)} ${theme.spacing(2)}`,
};
